var map = {
	"./en-US": "fbc3",
	"./en-US.js": "fbc3",
	"./zh-CN": "9ec3",
	"./zh-CN.js": "9ec3",
	"./zh-TW": "823d",
	"./zh-TW.js": "823d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "40b0";